import { ComponentProps } from "react";
import { Trustpilot } from "@travellocal/ui";
import { getCountryByCountrySlug } from "utils/api/site2";
import { Locale } from "@travellocal/utils";

export const getTrustpilotProps = ({
  locale,
  template = "mini",
  countryCode,
  trustpilotReviewSummary,
}: {
  locale: Locale;
  template?: ComponentProps<typeof Trustpilot>["template"];
  countryCode: string;
  trustpilotReviewSummary: Awaited<
    ReturnType<typeof getCountryByCountrySlug>
  >["tripBookingTrustpilotReviewSummaryForCountry"];
}): ComponentProps<typeof Trustpilot> => {
  const reviewForCurrentLocale = trustpilotReviewSummary.find(
    (summary) => summary.locale === locale
  );
  const countryHasReviewsInCurrentLocale =
    reviewForCurrentLocale?.summary.numberOfFiveStars > 0 ||
    reviewForCurrentLocale?.summary.numberOfFourStars > 0;

  if (countryHasReviewsInCurrentLocale) {
    // has 4,5 stars reviews in current locale
    return {
      locale,
      template,
      filters: { "data-tags": `ctr-${countryCode.toLowerCase()}` },
    };
  }
  if (!countryHasReviewsInCurrentLocale) {
    // no 4,5 stars reviews in current locale
    const reviewForEN = trustpilotReviewSummary.find((summary) => summary.locale === "en");
    const hasCountryReviewsInEN =
      reviewForEN?.summary.numberOfFiveStars > 0 || reviewForEN?.summary.numberOfFourStars > 0;

    if (hasCountryReviewsInEN) {
      // has 4,5 stars reviews in EN
      return {
        locale: "en",
        template,
        filters: { "data-tags": `ctr-${countryCode.toLowerCase()}` },
      };
    }

    // no 4,5 stars reviews in EN or current locale
    return {
      locale,
      template,
      filters: {},
    };
  }
};
